import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, VIEWPORT_DEFAULT } from '@/lib/motion';

/**
 * Container that staggers its <StaggerItem> children in as it scrolls into
 * view. Use for feature lists, card grids, nav items -- anywhere a group of
 * siblings should animate as one cascading unit rather than all at once.
 */
export const StaggerGroup = ({
  as: Tag = motion.div,
  stagger = 0.08,
  delayChildren = 0,
  viewport = VIEWPORT_DEFAULT,
  className,
  children,
  ...props
}) => (
  <Tag
    initial="hidden"
    whileInView="show"
    viewport={viewport}
    variants={staggerContainer(stagger, delayChildren)}
    className={className}
    {...props}
  >
    {children}
  </Tag>
);

export const StaggerItem = ({ as: Tag = motion.div, variants = fadeInUp, className, children, ...props }) => (
  <Tag variants={variants} className={className} {...props}>
    {children}
  </Tag>
);

export default StaggerGroup;
